import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="company-name">Way-Agri – Formation Agricole</p>
        <p className="contact-info">
          Téléphone: 01 89 70 56 07 | Email: <a href="mailto:Contact@wayup-agri.fr">Contact@wayup-agri.fr</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
